/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WearableDataSelectionDto } from './WearableDataSelectionDto';
import {
    WearableDataSelectionDtoFromJSON,
    WearableDataSelectionDtoFromJSONTyped,
    WearableDataSelectionDtoToJSON,
    WearableDataSelectionDtoToJSONTyped,
} from './WearableDataSelectionDto';

/**
 * 
 * @export
 * @interface DataSelectionCriteriaDto
 */
export interface DataSelectionCriteriaDto {
    /**
     * Array of diagnostic file IDs to include in treatment plan generation
     * @type {Array<string>}
     * @memberof DataSelectionCriteriaDto
     */
    diagnosticFilesSelectedIds?: Array<string>;
    /**
     * Wearable data date range selection
     * @type {WearableDataSelectionDto}
     * @memberof DataSelectionCriteriaDto
     */
    wearableData?: WearableDataSelectionDto;
}

/**
 * Check if a given object implements the DataSelectionCriteriaDto interface.
 */
export function instanceOfDataSelectionCriteriaDto(value: object): value is DataSelectionCriteriaDto {
    return true;
}

export function DataSelectionCriteriaDtoFromJSON(json: any): DataSelectionCriteriaDto {
    return DataSelectionCriteriaDtoFromJSONTyped(json, false);
}

export function DataSelectionCriteriaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataSelectionCriteriaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'diagnosticFilesSelectedIds': json['diagnosticFilesSelectedIds'] == null ? undefined : json['diagnosticFilesSelectedIds'],
        'wearableData': json['wearableData'] == null ? undefined : WearableDataSelectionDtoFromJSON(json['wearableData']),
    };
}

export function DataSelectionCriteriaDtoToJSON(json: any): DataSelectionCriteriaDto {
    return DataSelectionCriteriaDtoToJSONTyped(json, false);
}

export function DataSelectionCriteriaDtoToJSONTyped(value?: DataSelectionCriteriaDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'diagnosticFilesSelectedIds': value['diagnosticFilesSelectedIds'],
        'wearableData': WearableDataSelectionDtoToJSON(value['wearableData']),
    };
}

